import { useQuery } from 'react-query';

import { Program } from '../../entities';
import { useEnvironment } from '../../environment/useEnvironment';
import { getAssetUrl } from '../asset';
import { unauthorizedGet } from '../authorizedApi';
import { mapImageToPublicAsset } from '../../components/PropertiesAssets/assetHelper';

export const useFetchPrograms = (programidlist?: string[]) => {
  const { playerBasePath } = useEnvironment();

  const { isLoading, data, isError, error, refetch } = useQuery<any, Error>(
    `programinstance`,
    async () => {
      const getPrograms = unauthorizedGet(
        `/program?programidlist=${programidlist ?? ''}`
      );
      const response = await getPrograms();
      const data: Program[] = await response.json();

      // resolve images for list
      for (let i = 0; i < data.length; i++) {
        if (data[i].program.assetid) {
          data[i].program.resolvedsrc = await getAssetUrl(
            data[i].program.assetid ?? ''
          );
        } else {
          if (data[i].program.src) {
            data[i].program.resolvedsrc = data[i].program.src;
          } else {
            if (data[i].program.image !== undefined) {
              data[i].program.resolvedsrc = mapImageToPublicAsset(
                data[i].program.image,
                playerBasePath
              );
            } else {
              data[i].program.resolvedsrc = '';
            }
          }
        }
      }

      return data;
    },
    {
      retry: false,
    }
  );

  return {
    isLoading,
    isError,
    error,
    programs: data as Program[],
    refetch,
  };
};
